import { render, staticRenderFns } from "./PartnerResetPassword.vue?vue&type=template&id=2b705c82&"
import script from "./PartnerResetPassword.vue?vue&type=script&lang=js&"
export * from "./PartnerResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports